module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ec-Gc.a167a41d.png";